<template>
  <footer class="footer" :class="{'dark main-black dark-trigger-city enable_dark': dark_page}">
    <div class="wrapper">
      <div class="footer__logo">
        <a :href="'/'+ lang +'/news'">
          <svg class="icon logo-forestal-min">
            <use xlink:href="#logo-forestal-min" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
          </svg>
        </a>
      </div>

      <div class="footer__text">
        <p>{{ getFooter(allSettings.settings) }}</p>
      </div>

      <div class="footer__navs">
        <nav v-if="false" class="footer__nav">
          <h5>{{ trans.text.footer.shopAndRide }}</h5>
          <ul>
            <li v-for="model in models" v-if="showMenuModelLink(model)">
              <a :href="'/'+ lang +'/products/'+ model.slug">
                {{ getModelTitle(model) }}
              </a>
            </li>
          </ul>
        </nav>

        <nav class="footer__nav">
          <h5>{{ trans.text.footer.company }}</h5>
          <ul>
            <li>
              <a :href="`/${lang}/news`">{{ trans.text.footer.news }}</a>
            </li>
            <li v-for="page in allPages" v-if="page.category_id == 3">
              <a :href="getFooterMenuLink(page, lang)" :target="getFooterMenuTarget(page)">
                {{ getFooterMenu(page) }}
              </a>
            </li>
            <li>
              <a :href="`/${lang}/contact`">{{ trans.text.footer.contacts }}</a>
            </li>
          </ul>
        </nav>

        <nav class="footer__nav">
          <h5>{{ trans.text.footer.social }}</h5>
          <ul>
            <li><a href="https://www.instagram.com/forestalbikes/" target="_blank">Instagram</a></li>
            <li><a href="https://www.facebook.com/forestalbikes/" target="_blank">Facebook</a></li>
            <li><a href="https://www.youtube.com/channel/UCdum5pdNzVMg7g7fiUOdv7A"
                   target="_blank">YouTube</a></li>
            <li><a href="https://www.linkedin.com/company/forestal/" target="_blank">Linkedin</a></li>
            <li><a href="https://x.com/Forestalbikes" target="_blank">X</a></li>
          </ul>
        </nav>
        <nav class="footer__nav">
          <h5>{{ trans.text.footer.marketing }}</h5>
          <ul>
            <li>
              <a href="/en/media">Media Library</a>
            </li>
            <li v-for="page in allPages" v-if="page.category_id == 1">
              <a :href="getFooterMenuLink(page, lang)" :target="getFooterMenuTarget(page)">
                {{ getFooterMenu(page) }}
              </a>
            </li>
            <li v-if="false">
              <a href="#">{{ trans.text.footer.mediaLibrary }}</a>
            </li>
          </ul>
        </nav>

        <nav v-if="false" class="footer__nav">
          <h5>{{ trans.text.footer.forestalValues }}</h5>
          <ul>
            <li v-if="getShowPages">
              <a href="#">{{ trans.text.footer.forestalBrand }}</a>
            </li>
            <li v-for="page in allPages" v-if="getShowPages && page.category_id == 2">
              <a :href="getFooterMenuLink(page, lang)" :target="getFooterMenuTarget(page)">
                {{ getFooterMenu(page) }}
              </a>
            </li>
            <li>
              <a :href="`/${lang}/contact`">{{ trans.text.footer.contacts }}</a>
            </li>
          </ul>
        </nav>

        <div class="footer__nav">
          <subscribe-component
            id="footer-subscribe"
            :is-footer="true"
            :lang="lang"
            :trans="trans">
          </subscribe-component>
        </div>
      </div>

      <div class="footer__bt">
        <div class="footer__copy">
          <p>{{ trans.text.footer.copyright }}</p>
        </div>

        <div class="footer__links">
          <ul>
            <li v-for="(page, index) in allPages" v-if="page.category_id == 4">
              <a :href="getFooterMenuLink(page, lang)" :target="getFooterMenuTarget(page)">
                {{ getFooterMenu(page) }}
              </a>
            </li>
          </ul>
        </div>

        <div v-if="false" class="footer-lang">
          <div :ref="'currentLang'" class="footer-lang__current" @click.prevent="showLanguageBox()">
            {{ Language }}
          </div>
          <nav :ref="'languagesBox'" class="footer-lang__select">
            <ul>
              <li v-for="(lang, index) in supportedLanguages"
                  :class="isLanguageActive(lang) ? 'is-active' : ''">
                <a href="#" @click.prevent="setLanguage(lang)">
                  <span class="footer-lang__flag">
                    <img :alt="lang" :src="getLanguageFlagImage(lang)">
                  </span>
                  <span class="footer-lang__name">{{ lang.toUpperCase() }}</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Languages from '../translations';

export default {
  props: ['lang', 'trans'],
  data() {
    return {
      email: null,
      customMessage: null,
      success: null,
      failed: null,
      isAgree: false,
      subscribeLabelDefault: 'Join our newsletter'
    }
  },
  beforeMount() {
    window.axios.defaults.headers.common['lang'] = this.lang;
  },
  computed: {
    ...mapGetters(['allModels', 'allPages', 'allSettings', 'getShowPages', 'isAuth']),
    emailPlaceholder() {
      return this.trans.text.footer.emailPlaceholder
    },
    supportedLanguages() {
      return Object.getOwnPropertyNames(Languages).filter(lang => {
        return lang.length === 2;
      })
    },
    models() {
      return this.allModels.filter(model => {
        return model.coming_soon !== 1;
      });
    },
    Language() {
      return this.lang;
    },
    dark_page() {
      //!NUXT! NOT WORK
      const location = window.location.toString();
      return location.includes("products/aryon") && !location.includes("products/aryon-sc")
        || location.includes("products/hydra")
    }
  },
  methods: {
    ...mapActions(['getPages', 'getSettings', 'AuthUserEmail']),
    getModelTitle(model) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!model && !!model[`${prefix}model`]) {
        return model[`${prefix}model`]
      }
      return '';
    },
    getFooterMenuLink(page, lang) {
      if (!!page.outer_link) {
        if (lang !== 'en') {
          if (!!page[`${lang}_outer_link`]) {
            return page[`${lang}_outer_link`];
          }
        }
        return page.outer_link;
      } else {
        if (page.slug === 'dealers') {
          return `/${lang}/dealers`;
        }
        if (page.slug === 'partners') {
          return `/${lang}/partners`;
        }
        return `/${lang}/page/${page.slug}`;
      }
    },
    getFooterMenuTarget(page) {
      return !!page.new_tab ? '_blank' : '_self';
    },
    getFooter(settings) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }

      if (location.href.indexOf('/product') !== -1 && location.href.indexOf('/customize') === -1) {
        if (!!settings && !!settings[`${prefix}productFooter`]) {
          return settings[`${prefix}productFooter`]
        }
      } else {
        if (!!settings && !!settings[`${prefix}footer`]) {
          return settings[`${prefix}footer`]
        }
      }

      return '';
    },
    getFooterMenu(menu) {
      let prefix;
      let language = this.lang;
      prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!menu && !!menu[`${prefix}title`]) {
        return menu[`${prefix}title`]
      }
      return '';
    },
    showMenuModelLink(model) {
      return !!model.slider_img && (model.rel_prods_count > 0);
    },
    getLanguageFlagImage(lang) {
      return `/assets/images/flags/${lang}.png`
    },
    setLanguage(lang) {
      let ctx = this;
      let path = window.location.pathname
      if (lang !== this.lang) {
        location.href = path.replace(/^.{3}/g, `/${lang}`)
      } else {
        $(ctx.$refs.languagesBox).slideUp(250);
      }
    },
    showLanguageBox() {
      let toggler = $(this.$refs.languagesBox);
      toggler.slideDown(250);
    },
    isLanguageActive(lang) {
      if (!!this.lang) {
        return lang === this.lang;
      }
      return lang === 'en';
    },
    subscribe() {
      let ctx = this;
      let url = this.$path + `/subscribers`;
      axios.post(url, {email: this.email, lang: ctx.lang}).then(response => {
        ctx.email = null;
        ctx.success = true;
        ctx.failed = null;
        ctx.customMessage = response.data.message;
        setTimeout(function () {
          ctx.customMessage = null
          ctx.success = null;
          ctx.failed = null;
        }, 5000);
      }).catch(error => {
        ctx.success = null;
        ctx.failed = true;
        if (error.response && error.response.status === 403) {
          ctx.customMessage = error.response.data.message;
        } else {
          ctx.customMessage = 'Something went wrong, please try later';
        }
        setTimeout(function () {
          ctx.customMessage = null
          ctx.success = null;
          ctx.failed = null;
        }, 5000);
      })
    },
    mergeBasketWithSaved() {
      if (!localStorage.getItem('access_token')) {
        return;
      }

      let url = `${this.$path}/v2/basket-check-saved`;
      axios.post(url, {
        basket_id: localStorage.getItem('basket_id')
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
      }).then(response => {
        if (!response.data.id) {
          return;
        }

        localStorage.setItem('basket_id', response.data.id);

        this.$store.commit('baskets/setBasket', response.data);
        this.$store.commit('baskets/setProducts', response.data);
      }).catch(error => {

      });
    }
  },
  mounted() {
    this.subscribeLabelDefault = this.trans.text.footer.join
    this.getPages({
      path: this.$path,
    })
    this.getSettings({
      path: this.$path,
    })
    this.AuthUserEmail();
    this.mergeBasketWithSaved();
  }
}
</script>
<style scoped>

h4.error {
  color: #E41B1B;
}
</style>
